export const ZERO = 0;

export const ONE = 1;

export const ZERO_CHAR = '0';

export const PERIOD = '.';

export const DEFAULT_ACH_LIMIT = 6000;

export const TODAYS_DATE = new Date();

// Labels for the months to be displayed in the report revenue page
export const MONTHS_IN_YEAR = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// Labels for the quarters to be displayed in the report revenue page
export const QUARTERS_IN_YEAR = [
  'Jan - Mar',
  'Apr - Jun',
  'Jul - Sep',
  'Oct - Dec',
]

export const MAX_FILE_SIZE = 4 * 1000 * 1000; // Byte -> Kilobyte -> Megabyte * 4 => 4 MB

export const DEFAULT_FORM_VALUE = '';

export const PROOF_OF_OWNERSHIP = 'proof_of_ownership';
export const PROOF_OF_RESIDENCE = 'proof_of_residence';

export const APPLY_ERROR_PHASES = {
  NoAPNForProperty: 'NoAPNForProperty',
  NoPropertyForAPN: 'NoPropertyForAPN',
  APNHasLicenses: 'APNHasLicenses',
};

// Information for the additional reporting periods modal in the Pay flow
export const BASE_ADDITIONAL_TAXABLE_MONTHS = [
  { label: 'January', index: 0 },
  { label: 'February', index: 1 },
  { label: 'March', index: 2 },
  { label: 'April', index: 3 },
  { label: 'May', index: 4 },
  { label: 'June', index: 5 },
  { label: 'July', index: 6 },
  { label: 'August', index: 7 },
  { label: 'September', index: 8 },
  { label: 'October', index: 9 },
  { label: 'November', index: 10 },
  { label: 'December', index: 11 },
];

// This is used for initializing the form state. Should be renamed to taxableReceiptsInit
export const BASE_ADDITIONAL_TAXABLE_QUARTERS = [
  {
    label: "Jan - Mar",
    qLabel: "Q1",
    index: 0,
    checked: false,
    longLabel: (year) => `January ${year} to March ${year}`,
    makeDateStart: (year) => `${year}-01-01`,
    makeDateEnd: (year) => `${year}-03-31`,
    grossRevenue: "",
    grossRevenueError: "",
    grossExemptRevenue: "",
    grossExemptRevenueError: ""
  },
  {
    label: "Apr - Jun",
    qLabel: "Q2",
    index: 1,
    checked: false,
    longLabel: (year) => `April ${year} to June ${year}`,
    makeDateStart: (year) => `${year}-04-01`,
    makeDateEnd: (year) => `${year}-06-30`,
    grossRevenue: "",
    grossRevenueError: "",
    grossExemptRevenue: "",
    grossExemptRevenueError: ""
  },
  {
    label: "Jul - Sep",
    qLabel: "Q3",
    index: 2,
    checked: false,
    longLabel: (year) => `July ${year} to September ${year}`,
    makeDateStart: (year) => `${year}-07-01`,
    makeDateEnd: (year) => `${year}-09-30`,
    grossRevenue: "",
    grossRevenueError: "",
    grossExemptRevenue: "",
    grossExemptRevenueError: ""
  },
  {
    label: "Oct - Dec",
    qLabel: "Q4",
    index: 3,
    checked: false,
    longLabel: (year) => `October ${year} to December ${year}`,
    makeDateStart: (year) => `${year}-10-01`,
    makeDateEnd: (year) => `${year}-12-31`,
    grossRevenue: "",
    grossRevenueError: "",
    grossExemptRevenue: "",
    grossExemptRevenueError: ""
  }
];


// LUI - Labelled User Interfaces
export const LUITypes = {
  text: 'text',
}

export const NUM_DAYS_OCCUPIED = 'numDaysOccupied';

export const NUM_DAYS_AVAILABLE = 'numDaysAvailable';

export const TAXABLE_RECEIPTS = 'taxableReceipts';

export const MAX_AMOUNT_REPORTABLE = 10000000;

export const FIRST_DAY_IN_MONTH = '01';

export const loginPhases = {
  EMAIL_ENTRY: 'EMAIL_ENTRY',
  CODE_ENTRY: 'CODE_ENTRY',
};

/* values in this mapping must be identical to flow names from stats response */
export const FLOWS = {
  UPDATE_CERTIFICATE: 'updateCertificate',
  UPDATE_LICENSE: 'updateLicense',
  TBID: 'tbid',
  RENEW_LICENSE: 'renewLicense',
  APPLY_LICENSE: 'applyLicense',
  PAY_TOT: 'payTot',
}
